
const mergeData = (dbData, laData) => {
  const databaseTransactions = dbData.db;
  // Combine Pie Chart Data
  const normalizeKey = (key) => {
    if (key === "Referal") return "Referral";
    if (key === "IT Lab Issue") return "ITS";
    return key;
  };

  const combinedPieChartData = [
    databaseTransactions.pieChartData,
    laData.pieChartData
  ].reduce((acc, dataSource) => {
    Object.entries(dataSource).forEach(([key, value]) => {
      const normalizedKey = normalizeKey(key);
      acc[normalizedKey] = (acc[normalizedKey] || 0) + value;
    });
    return acc;
  }, {});

  // Combine Bar Graph Data
  const combinedBarGraphData = Object.keys(databaseTransactions.barGraphData).reduce((acc, key) => {
    acc[key] = (databaseTransactions.barGraphData[key] || 0) + (laData.barGraphData[key] || 0);
    return acc;
  }, {});

  // Combine Line Graph Data
  const combinedLineGraphData = Object.keys(databaseTransactions.lineGraphData).reduce((acc, key) => {
    acc[key] = databaseTransactions.lineGraphData[key].map((value, index) => (value || 0) + (laData.lineGraphData[key][index] || 0));
    return acc;
  }, {});

  const gateCountGraph = Object.keys(dbData.gateCounts).reduce((acc, key) => {
    acc[key] = dbData.gateCounts[key].map((value, index) => (value || 0) + (dbData.gateCounts[key][index] || 0));
    return acc;
  }, {});

  // Combine Total Transactions
  const totalTransactions = (databaseTransactions.DbTransactions || 0) + (laData.libAnswersTransactions || 0);

  return {
      totalTransactions,
      DbTransactions: databaseTransactions.DbTransactions,
      libAnswersTransactions: laData.libAnswersTransactions,
      pieChartData: combinedPieChartData,
      barGraphData: combinedBarGraphData,
      lineGraphData: combinedLineGraphData,
      gateCountLineGraph: gateCountGraph,
    };
};

export default mergeData;
